var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageoffre"}},[_c('Header'),(_vm.$store.state.offre_active)?_c('main',[_c('Pages')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }